import { useEffect } from 'react';
import { useCompassCard } from '@scale/compass-ui/store';
import type { PercentageContext } from '@scale/genai-compass-shared/cards/percentage';
import { CalculationType } from '@scale/genai-compass-shared/cards/percentage';

function usePercentageCard(index: number) {
  const { card, updateCardContext, updateCardCanSubmit } = useCompassCard(index);
  const { retrievedOutput } = useCompassCard(index - 1);
  const context = card.defaultContext as PercentageContext;
  const columns = retrievedOutput?.response?.schema ?? [];

  useEffect(() => {
    updateCardCanSubmit(context.selectedColumnIds.length > 0);
  }, [context.calculationType, context.selectedColumnIds, updateCardCanSubmit]);

  const setCalculationType = (calculationType: CalculationType) => {
    updateCardContext({ ...context, calculationType } as PercentageContext);
  };

  const setSelectedColumnIds = (selectedColumnIds: string[]) => {
    updateCardContext({ ...context, selectedColumnIds } as PercentageContext);
  };

  return {
    card,
    calculationType: context.calculationType,
    selectedColumnIds: context.selectedColumnIds,
    setCalculationType,
    allColumns: columns,
    setSelectedColumnIds,
  };
}

export default usePercentageCard;
